import React, { useContext, useState } from 'react'
import { useParams } from 'react-router';
import { hostContext } from '../../context/hostContext';

import useForm from '../../hooks/useForm';

import apiAsistentes from '../../services/apis/apiAsistentes';

import style from '../../assets/styles/perfil-descargar.module.css'

const Formulario = () => {

    const { id } = useParams();
    const { setEventosAsistidos } = useContext( hostContext )
    const [error, setError] = useState( null );

    const { values, handleInputChange, reset } = useForm({
        correo: ''
    });
    const { correo } = values;

    const enviarFormulario = async(e) => {
        e.preventDefault();
        setEventosAsistidos(null);
        
        const buscarEventosAsistidos = await apiAsistentes.getAll({ params: {correo: String(correo), id_organizador: id} } );
        if( !buscarEventosAsistidos.ok ){ return setError('Correo no encontrado en la base de datos.') }
        
        setError(null);
        const eventos = buscarEventosAsistidos.response.data.asistentes;
        setEventosAsistidos( eventos )
        
        reset();
    }

    return (<>
        { <form onSubmit={enviarFormulario}>

                <div className='rowStyleForm' >
                    <input type="email" name="correo" value={correo} onChange={handleInputChange} 
                    className="mr-1" placeholder="Ingresa tu correo" />
                    <button className='bg-primary' > Buscar </button>
                </div>



        </form>}

        { error && 
            <div className={style.mensaje_de_error}>
                <p>{error}</p>
                <p>Si tiene problemas para encontrar su constancia
                    contacte al administrador.
                </p>
            </div>
        }
        
    </>)
}

export default Formulario
